import { useRouter } from 'next/router';
import TenantConfig from '@framework/tenant/TenantConfig';
import staticUrls from '@finsight/urls/static';
import cfrUrl from '@/creditflowresearch/infrastructure/url';
import usersUrl from '@users/url';
import cn from 'classnames';
import ContactSupport from '@framework/ui/Molecules/ContactSupport';
import { Spinner } from '@creditflowresearch/uilib/Loader/Spinner';
import isServer from '@framework/router/Next/isServer';
import URL from '@/creditflowresearch/Router/urlConstants';
import { Link } from '@framework/router/Next/Link';
import CheckUserAccess from '@/creditflowresearch/ui/common/components/CheckUserAccess';
import { useUserPlanContext } from '@/creditflowresearch/application/User/UserPlan/UserPlanContext';
import { UserPlanType } from '@creditflowresearch/user-plan/UserPlan';

import styles from './userProfileMenuLinks.module.scss';

interface IUserProfileMenuLinksProps {
  onClose?: () => void,
}

const UserProfileMenuLinks = ({ onClose }: IUserProfileMenuLinksProps) => {
  const { asPath } = useRouter();
  const { checkAccessByUserPlan } = useUserPlanContext();

  const settingsAccess = [{ checks: [checkAccessByUserPlan(UserPlanType.STARTER)] }];
  const closeMenu = () => onClose?.();

  const getLogoutUrl = () => {
    if (isServer()) {
      return null;
    }

    return cfrUrl.getLogoutUrl(asPath);
  };

  return (
    <div
      data-test="dropdownUserProfileMenuLinks"
      className={ styles.profileDropdownContent }
    >
      <div className={ styles.section }>
        <Link
          dataTest="myProfileLink"
          to={ usersUrl.getProfileUrl(TenantConfig.fromHostname().code) }
        >
          My Profile
        </Link>
        <Link
          dataTest="emailSubscriptionsLink"
          to={ URL.SUBSCRIPTIONS }
          onClick={ closeMenu }
        >
          My Subscriptions
        </Link>
        <CheckUserAccess conditions={ settingsAccess }>
          <Link
            dataTest="settingsLink"
            to={ URL.SETTINGS }
            onClick={ closeMenu }
          >
            Settings
          </Link>
        </CheckUserAccess>
      </div>

      <div className={ styles.section }>
        <Link
          dataTest="termsOfUseLink"
          to={ staticUrls.getTermsOfUseUrl() }
          target="_blank"
        >
          Terms of Use
        </Link>
        <Link
          dataTest="privacyPolicyLink"
          to={ staticUrls.getPrivacyPolicyUrl() }
          target="_blank"
        >
          Privacy Policy
        </Link>
        <ContactSupport>
          { (isLoading) => (
            <a>
              Live Tech Support
              <span className={ cn({ [styles.hiddenSpinner]: !isLoading }) }>
                <Spinner size="XS" />
              </span>
            </a>
          ) }
        </ContactSupport>
      </div>

      <div className={ styles.section }>
        <a
          data-test="logOutButton"
          href={ getLogoutUrl() }
          className={ styles.logoutLink }
        >
          Log Out
        </a>
      </div>
    </div>
  );
};

export default UserProfileMenuLinks;
